import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Save, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminPages = () => {
  const [pages, setPages] = useState([]);
  const [slug, setSlug] = useState('cgv');
  const [form, setForm] = useState({ title: '', content: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/pages`).then(({ data }) => setPages(data)).catch(console.error);
  }, []);

  useEffect(() => {
    axios.get(`${API}/pages/${slug}`).then(({ data }) => setForm({ title: data.title, content: data.content })).catch(console.error);
  }, [slug]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/admin/pages/${slug}`, form, { withCredentials: true });
      toast.success('Page enregistrée');
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
    finally { setSaving(false); }
  };

  const hasPlaceholders = /\[[A-ZÀ-Ü][^\]]*\]/.test(form.content);

  return (
    <div className="bg-white rounded-sm border border-border p-6">
      <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>Pages légales</h2>
      <p className="text-sm text-muted-foreground mb-4">CGV, mentions légales, confidentialité et livraison. Les textes entre crochets <span className="font-mono">[…]</span> sont à remplacer par vos informations.</p>

      <div className="flex gap-1 border-b border-border mb-4 overflow-x-auto">
        {pages.map((p) => (
          <button key={p.slug} onClick={() => setSlug(p.slug)}
            className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 ${slug === p.slug ? 'border-brand-orange text-brand-orange' : 'border-transparent text-muted-foreground hover:text-foreground'}`}
            data-testid={`page-tab-${p.slug}`}>
            {p.title}
          </button>
        ))}
      </div>

      <form onSubmit={save} className="space-y-3">
        <div>
          <label className="block text-xs font-medium mb-1">Titre</label>
          <input type="text" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
            className="w-full px-3 py-2 border border-border rounded-sm" data-testid="page-title-input" />
        </div>
        <div>
          <label className="block text-xs font-medium mb-1">Contenu</label>
          <textarea required rows="22" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })}
            className="w-full px-3 py-2 border border-border rounded-sm text-sm font-mono leading-relaxed" data-testid="page-content-input" />
        </div>
        {hasPlaceholders && (
          <p className="text-xs text-yellow-800 bg-yellow-50 border border-yellow-300 rounded-sm p-2" data-testid="page-placeholder-warning">
            Cette page contient encore des champs entre crochets à compléter (raison sociale, SIRET, adresse…).
          </p>
        )}
        <div className="flex gap-2 items-center">
          <button type="submit" disabled={saving} className="btn-primary px-4 py-2 rounded-sm font-medium flex items-center gap-2 disabled:opacity-50" data-testid="save-page-button">
            <Save className="w-4 h-4" /> {saving ? 'Enregistrement…' : 'Enregistrer'}
          </button>
          <a href={`/pages/${slug}`} target="_blank" rel="noreferrer" className="text-sm text-brand-orange hover:underline flex items-center gap-1" data-testid="preview-page-link">
            Voir la page <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </form>
    </div>
  );
};
